import { Layout, Typography, Divider } from "antd";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const Impressum = () => {
  return (
    <Layout className="min-h-screen bg-gray-100">
      <Content className="p-4 md:p-8 max-w-4xl mx-auto">
        <div className="bg-white shadow-md rounded-lg p-6 md:p-8">
          <Title level={2} className="text-center mb-6">
            Impressum
          </Title>

          <Title level={4}>Angaben gemäß § 5 TMG</Title>
          <Paragraph>
            Dierker & Viere GbR
            <br />
            Lerchenstraße 34
            <br />
            49577 Kettenkamp
          </Paragraph>

          <Divider />

          <Title level={4}>Vertreten durch</Title>
          <Paragraph>Moritz Dierker und Jan-Paul Viere</Paragraph>

          <Divider />

          <Title level={4}>Kontakt</Title>
          <Paragraph>
            Telefon: 015759522722
            <br />
            E-Mail: info@reebaq.de
          </Paragraph>

          <Divider />

          <Title level={4}>Umsatzsteuer-ID</Title>
          <Paragraph>
            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
            <br />
            DE453829726
          </Paragraph>

          <Divider />

          <Title level={4}>
            Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
          </Title>
          <Paragraph>
            Moritz Dierker und Jan-Paul Viere
            <br />
            Lerchenstraße 34
            <br />
            49577 Kettenkamp
          </Paragraph>

          <Divider />

          <Title level={4}>Streitschlichtung</Title>
          <Paragraph>
            Die Europäische Kommission stellt eine Plattform zur
            Online-Streitbeilegung (OS) bereit:&nbsp;
            <a
              href="https://ec.europa.eu/consumers/odr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              https://ec.europa.eu/consumers/odr
            </a>
            .<br />
            Unsere E-Mail-Adresse finden Sie oben im Impressum.
          </Paragraph>

          <Paragraph>
            Wir sind nicht bereit oder verpflichtet, an
            Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
            teilzunehmen.
          </Paragraph>
        </div>
      </Content>
    </Layout>
  );
};

export default Impressum;
